function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: 'Checkbox',
  inheritAttrs: false,
  model: {
    prop: 'checked'
  },
  props: {
    prefixCls: {
      type: String,
      default: 'v-checkbox'
    },
    type: {
      type: String,
      default: 'checkbox',
      validator: function validator(val) {
        return ['radio', 'checkbox'].indexOf(val) > -1;
      }
    },
    checked: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    control: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerChecked: false
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          innerChecked = this.innerChecked,
          disabled = this.disabled;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-checked"), innerChecked), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), disabled), _ref;
    }
  },
  watch: {
    checked: function checked(nVal, oVal) {
      if (nVal !== oVal) {
        this.innerChecked = nVal;
      }
    }
  },
  created: function created() {
    this.innerChecked = this.checked;
  },
  methods: {
    getValue: function getValue() {
      return this.innerChecked;
    },
    onChange: function onChange(e) {
      var disabled = this.disabled,
          $props = this.$props,
          control = this.control;

      if (disabled) {
        return;
      }

      var checked = e.target.checked;

      if (!control) {
        this.innerChecked = checked;
      }

      this.$emit('input', checked);
      this.$emit('change', {
        target: _objectSpread({}, $props, {
          checked: checked
        }),
        domEvent: e
      });
    },
    focus: function focus() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.focus();
      }
    },
    blur: function blur() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.blur();
      }
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    class: _vm.classes
  }, [_c('input', _vm._b({
    ref: "inputRef",
    class: _vm.prefixCls + "-input",
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.innerChecked,
      "value": _vm.value
    },
    on: {
      "change": _vm.onChange
    }
  }, 'input', _vm.$attrs, false)), _vm._v(" "), _c('span', {
    class: _vm.prefixCls + "-inner"
  })]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "checkbox.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);